import BResourcePage from '../../components/resources/BResourcePage';

function RankingPage() {
  return (
    <BResourcePage
      title={'Rangfolge'}
      url={'/brokers/stats'}
      isReadOnly={true}
      fieldsVisibleAtBeginning={['id', 'firstName', 'lastName', 'points', 'place', 'Estimations Number', 'Estimations Average']}
    />
  );
}

export default RankingPage;
